const riot = require('riot');

riot.tag2('modal-error', '<div class="modal container-538 py16 rounded-4 bg-white" ref="modal"> <div class="s-full" data-is="module-error" status-code="{statusCode}" error-message="{errorMessage}"></div> </div>', 'modal-error .modal,[data-is="modal-error"] .modal{width:80%;max-height:60%}', 'class="f fh s-full px16 bg-modal_overlay" spat-animation="fade"', function(opts) {
    this.on('mount', () => {
      let { statusCode, errorMessage } = app.utils.getErrorItem({ status_code: this.opts.statusCode });
      this.statusCode = statusCode;
      this.errorMessage = errorMessage;
      this.update();
    });
});